import { Component, EventEmitter, Input, Output, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SVGIcon, xIcon } from '@progress/kendo-svg-icons';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { BaseComponent } from 'src/app/core/shared/common/base.component';

/**
 * Customer Names Popup Component
 * Displays the list of customer names included in a scheduled report
 */
@Component({
  selector: 'app-customer-names-popup',
  templateUrl: './customer-names-popup.component.html',
  styleUrls: ['./customer-names-popup.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonsModule, IconsModule],
})
export class CustomerNamesPopupComponent extends BaseComponent {
  private _customerNames: string[] = [];

  @Input()
  set customerNames(value: string[]) {
    this._customerNames = value || [];
    this.allCustomerNames.set(value || []);
  }

  get customerNames(): string[] {
    return this._customerNames;
  }

  @Output() close = new EventEmitter<void>();

  public xIcon: SVGIcon = xIcon;

  // Search state
  public searchQuery = signal<string>('');

  // All customer names (original list)
  public allCustomerNames = signal<any[]>([]);

  // Filtered customer names based on search
  public filteredCustomerNames = computed(() => {
    const query = this.searchQuery().toLowerCase().trim();
    const names = this.allCustomerNames();

    if (!query) {
      return names;
    }

    return names.filter((item) =>
      item.name.toLowerCase().includes(query.toLowerCase())
    );
  });

  /**
   * Handle close event
   */
  public onClose(): void {
    this.close.emit();
  }

  /**
   * Clear search query
   */
  public clearSearch(): void {
    this.searchQuery.set('');
  }
}
